import React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

export default function SortableHeader({
    label,
    sortKey,
    currentSort,
    currentOrder,
    onSort,
    className = ""
}) {
    const isActive = currentSort === sortKey;

    const handleClick = () => {
        if (isActive) {
            onSort(sortKey, currentOrder === "asc" ? "desc" : "asc");
        } else {
            onSort(sortKey, "asc");
        }
    };

    return (
        <th 
            scope="col" 
            className={`px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-50 select-none ${className}`}
            onClick={handleClick}
        >
            <div className="flex items-center gap-1">
                {label}
                {isActive && (
                    <span className="text-gray-900">
                        {currentOrder === "asc" ? (
                            <ArrowUp className="h-3 w-3" />
                        ) : (
                            <ArrowDown className="h-3 w-3" />
                        )}
                    </span>
                )}
            </div>
        </th>
    );
}
